<div class="documents-page">
    <ion-card *ngIf="nezet === 'export'">
      <ion-card-header>
        <ion-card-title>Adatkinyerések</ion-card-title>
        <ion-card-subtitle>
          Itt gyűjtjük az adminisztrációs exportokat, dokumentumletöltéseket és a jogszabály szerinti kötelező nyomtatványokat.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-list lines="full">
          <ion-item>
            <ion-icon name="school-outline" slot="start"></ion-icon>
            <ion-label>
              <h2>Tanulói értékelések exportja</h2>
              <p>
                Letölti az idei tanévben beírt összes tanulói értékelést minden rögzített és kapcsolódó adattal.
                <ng-container *ngIf="tanevLabel">Aktuális tanév: {{ tanevLabel }}.</ng-container>
              </p>
            </ion-label>
            <ion-button
              slot="end"
              color="success"
              (click)="ertekelesekExport()"
              [disabled]="exportFolyamatban || !jogosult"
            >
              <ion-icon slot="start" name="download-outline"></ion-icon>
              Excel letöltése
            </ion-button>
          </ion-item>

          <!-- Tanulói törzsadat-export: intézményre vagy egy osztályra szűrve -->
          <ion-item lines="none">
            <ion-icon name="people-outline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              <h2>Tanulói adatok exportja</h2>
              <p>
                A tanulók teljes törzsadata (személyes adatok, címek, TAJ, adóazonosító,
                tankötelezettség, SNI/BTMN), a jogviszony és az osztály adatai, valamint
                a gondviselők elérhetőségei egy Excel táblában.
              </p>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-select
              label="Szűrés"
              label-placement="stacked"
              interface="popover"
              [(ngModel)]="tanuloExportOsztaly"
            >
              <ion-select-option [value]="''">Teljes intézmény</ion-select-option>
              <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">
                {{ o.osztaly }}
              </ion-select-option>
            </ion-select>
            <ion-checkbox
              slot="end"
              class="gondviselo-kapcsolo"
              [checked]="tanuloExportGondviselo"
              (ionChange)="tanuloExportGondviselo = $event.detail.checked"
              labelPlacement="start"
            >Gondviselők</ion-checkbox>
            <ion-button
              slot="end"
              color="success"
              (click)="tanulokExport()"
              [disabled]="tanuloExportFolyamatban || !jogosult"
            >
              <ion-icon slot="start" name="download-outline"></ion-icon>
              Excel letöltése
            </ion-button>
          </ion-item>
        </ion-list>

        <ion-note color="warning" *ngIf="!jogosult">
          Ez a menüpont jelenleg csak admin jogosultsággal használható.
        </ion-note>

        <app-kotelezo-nyomtatvanyok [jogosult]="jogosult"></app-kotelezo-nyomtatvanyok>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="nezet === 'generalas'">
      <ion-card-header>
        <ion-card-title>Záróértékelés dokumentumok</ion-card-title>
        <ion-card-subtitle>
          Osztály szintű PDF generálása a szöveges záróértékelésekből. Válaszd ki a
          sablont (töprengő vagy bizonyítvány pótlap), az osztályt, a dátumot és a
          típust, majd töltsd le a dokumentumot. A tantárgyak sorrendjét a
          Kerettanterv menüben állíthatod be.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-item lines="full">
          <ion-input
            label="Intézményvezető neve"
            label-placement="stacked"
            [(ngModel)]="intezmenyvezeto"
            placeholder="pl. Dr. Kovács Anna"
          >
            <ion-icon slot="start" name="person-outline" aria-hidden="true"></ion-icon>
          </ion-input>
          <ion-button slot="end" fill="outline" size="small" [disabled]="intezmenyvezetoMentes" (click)="saveIntezmenyvezeto()">
            Mentés
          </ion-button>
        </ion-item>
        <ion-note color="medium" class="ion-margin-start" style="display:block; font-size:.8rem; margin:2px 0 10px 8px;">
          A bizonyítvány-sablon <code>{{ '{{ intezmenyvezeto }}' }}</code> mezőjéhez.<span *ngIf="intezmenyNev"> Intézmény: {{ intezmenyNev }}.</span>
        </ion-note>

        <!--  Munkábajárás térítése: intézményi díj (feladatellatas.benzinpenz). Külön mentődik,
              az intézményvezető nevét nem érinti. -->
        <ion-item lines="full">
          <ion-input
            label="Munkába járás térítése (Ft/km)"
            label-placement="stacked"
            type="number"
            min="0"
            [(ngModel)]="benzinpenz"
            placeholder="pl. 30"
          >
            <ion-icon slot="start" name="car-outline" aria-hidden="true"></ion-icon>
          </ion-input>
          <ion-button slot="end" fill="outline" size="small" [disabled]="benzinpenzMentes" (click)="saveBenzinpenz()">
            Mentés
          </ion-button>
        </ion-item>
        <ion-note color="medium" class="ion-margin-start" style="display:block; font-size:.8rem; margin:2px 0 10px 8px;">
          A dolgozó napi km-e (oda-vissza) × munkanapjai × ez a díj. A napi km-t, az útvonalat és a
          rendszámot a dolgozó adatlapján (Állomány › Munkaügy) lehet megadni.
        </ion-note>

        <!--  Intézménytípus (digitális / papír bizonyítvány, szakképzési sablon) és a díszpéldány díja;
              szakképzőben az ágazati alapvizsgák (backend/bizonyitvany-tipus.js, agazati-alapvizsga.js). -->
        <div style="display:flex; flex-wrap:wrap; gap:6px; margin:0 0 12px 8px;">
          <ion-button fill="outline" size="small" (click)="intezmenytipus()">
            <ion-icon slot="start" name="school-outline"></ion-icon>Intézménytípus és díszpéldány-díj
          </ion-button>
          <ion-button fill="outline" size="small" (click)="agazatiAlapvizsga()">
            <ion-icon slot="start" name="construct-outline"></ion-icon>Ágazati alapvizsgák
          </ion-button>
        </div>

        <ion-list lines="full">
          <ion-item>
            <ion-select
              label="Sablon"
              label-placement="stacked"
              interface="popover"
              [(ngModel)]="sablon"
            >
              <ion-select-option value="toprengo">Töprengő (szöveges záróértékelés)</ion-select-option>
              <ion-select-option value="bizonyitvany_potlap">Bizonyítvány pótlap</ion-select-option>
              <ion-select-option value="bizonyitvany">Bizonyítvány</ion-select-option>
              <ion-select-option value="torzslap">Törzslap</ion-select-option>
            </ion-select>
          </ion-item>

          <!--  Nkt. 57. § (5): a szabad (Word-)sablon csak a digitális bizonyítványhoz és a díszpéldányhoz
                használható; a papír bizonyítvány a jóváhagyott, előnyomott nyomtatványra készül (lent). -->
          <ion-item *ngIf="sablon === 'bizonyitvany' || sablon === 'bizonyitvany_potlap'" lines="none">
            <ion-icon name="warning-outline" slot="start" color="warning" aria-hidden="true"></ion-icon>
            <ion-label class="ion-text-wrap">
              <p class="sablon-figyelmeztetes">
                Szabad formátumú sablon csak a digitális bizonyítványhoz és a díszpéldányhoz használható; papír bizonyítvány
                csak jóváhagyott, előnyomott nyomtatványon adható ki. A nem digitális évfolyamok bizonyítványát a
                <b>Papír bizonyítvány nyomtatása</b> gombbal töltsd ki a nyomtatványra.
              </p>
            </ion-label>
          </ion-item>

          <ion-item *ngIf="sablon === 'bizonyitvany' || sablon === 'bizonyitvany_potlap'">
            <ion-checkbox
              slot="start"
              [checked]="bizonyitvanyAlairTarol"
              (ionChange)="bizonyitvanyAlairTarol = $event.detail.checked"
            ></ion-checkbox>
            <ion-label class="ion-text-wrap">
              Digitális aláírás és tárolás (a szülő letöltheti)
              <p *ngIf="sablon === 'bizonyitvany'">Bekapcsolva: tanulónként aláírja és elmenti a bizonyítványt (keltezés, sorszám, nevelőtestületi határozat a következő ablakban). Kikapcsolva: csak letölthető PDF (nyomtatáshoz).</p>
              <p *ngIf="sablon === 'bizonyitvany_potlap'">Bekapcsolva: a kijelölt tanulóknak aláírt, időbélyegzett pótlapot készít, és a dokumentumtárba menti. Kikapcsolva: csak letölthető PDF (nyomtatáshoz).</p>
            </ion-label>
          </ion-item>

          <ion-item *ngIf="sablon === 'torzslap'">
            <ion-checkbox
              slot="start"
              [checked]="torzslapAlairTarol"
              (ionChange)="torzslapAlairTarol = $event.detail.checked"
            ></ion-checkbox>
            <ion-label class="ion-text-wrap">
              Aláírás, időbélyeg és tárolás tanulónként
              <p>
                Bekapcsolva: az osztály minden tanulójának törzslapja aláírva, időbélyeggel a dokumentumtárba kerül
                (Iktatgatóval a „Törzslapok” könyvbe iktatva, nem selejtezhető tételre); az újragenerált példány a
                régit váltja. Tanév elején, értékelés nélkül is kiállítható. Kikapcsolva: csak nyomtatható PDF.
              </p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-select
              label="Osztály"
              label-placement="stacked"
              interface="popover"
              placeholder="Válassz osztályt"
              [(ngModel)]="kivosztaly"
            >
              <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">
                {{ o.osztaly }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Dátum (üres = mai)</ion-label>
            <ion-input type="date" [(ngModel)]="toprengoDatum"></ion-input>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Dátum formátuma</ion-label>
            <ion-segment [(ngModel)]="datumElvalaszto">
              <ion-segment-button value="kotojel">
                <ion-label>Kötőjel (2026-06-09)</ion-label>
              </ion-segment-button>
              <ion-segment-button value="pont">
                <ion-label>Pont (2026.06.09.)</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-item>

          <ion-item>
            <ion-checkbox
              slot="start"
              [checked]="csakElsoKeresztnev"
              (ionChange)="csakElsoKeresztnev = $event.detail.checked"
            ></ion-checkbox>
            <ion-label>Osztályfőnöknél csak az első keresztnév</ion-label>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked">Típus</ion-label>
            <ion-segment [(ngModel)]="zaroTipus">
              <ion-segment-button value="2">
                <ion-label>Félévi</ion-label>
              </ion-segment-button>
              <ion-segment-button value="3">
                <ion-label>Év végi</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-item>
        </ion-list>

        <div class="ion-padding-top">
          <ion-button
            color="secondary"
            (click)="generate()"
            [disabled]="toprengoFolyamatban || !kivosztaly"
          >
            <ion-icon slot="start" [name]="(((sablon === 'bizonyitvany' || sablon === 'bizonyitvany_potlap') && bizonyitvanyAlairTarol) || (sablon === 'torzslap' && torzslapAlairTarol)) ? 'shield-checkmark-outline' : 'document-text-outline'"></ion-icon>
            <ng-container [ngSwitch]="sablon">
              <ng-container *ngSwitchCase="'bizonyitvany_potlap'">
                {{ bizonyitvanyAlairTarol ? 'Pótlap aláírása és tárolása' : 'Bizonyítvány pótlap PDF' }}
              </ng-container>
              <ng-container *ngSwitchCase="'bizonyitvany'">
                {{ bizonyitvanyAlairTarol ? 'Bizonyítvány aláírása és tárolása' : 'Bizonyítvány PDF' }}
              </ng-container>
              <ng-container *ngSwitchCase="'torzslap'">
                {{ torzslapAlairTarol ? 'Törzslap aláírása és tárolása' : 'Törzslap PDF' }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                Töprengő PDF ({{ zaroTipus === '3' ? 'év végi' : 'félévi' }})
              </ng-container>
            </ng-container>
          </ion-button>
          <!--  Papír bizonyítvány jóváhagyott nyomtatványra + szigorú számadás (papir-bizonyitvany.component). -->
          <ion-button color="tertiary" fill="outline" (click)="papirBizonyitvany()">
            <ion-icon slot="start" name="print-outline"></ion-icon>
            Papír bizonyítvány nyomtatása
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- A törzslap 30 napos kiállítási határideje (20/2012. EMMI r. 99. § (1)) – backend/torzslap.js -->
    <app-torzslap-hatarido
      *ngIf="nezet === 'generalas'"
      [intezmeny]="intezmenyAzon"
      [ev]="aktTanevEv"
      [datum]="toprengoDatum"
      [datumFormat]="datumElvalaszto"
      [csakElsoKeresztnev]="csakElsoKeresztnev"
    ></app-torzslap-hatarido>

    <ion-card *ngIf="nezet === 'lista'">
      <ion-card-header>
        <ion-card-title>Generált dokumentumok</ion-card-title>
        <ion-card-subtitle>
          Az intézményben generált dokumentumok (bizonyítvány stb.). Keress tanulónévre,
          oktatási azonosítóra vagy dokumentumnévre, és szűrj típusra. A felülírt (újragenerált)
          korábbi kiállítások „régi verzió"-ként, fájl nélkül maradnak meg.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="12" size-md="6">
              <ion-input
                label="Keresés"
                label-placement="stacked"
                fill="outline"
                [(ngModel)]="dokKereso"
                (keyup.enter)="loadGeneraltDokumentumok()"
                placeholder="Tanuló neve / oktatási azonosító / dokumentum neve"
              >
                <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
              </ion-input>
            </ion-col>
            <ion-col size="8" size-md="4">
              <ion-select
                label="Típus"
                label-placement="stacked"
                fill="outline"
                interface="popover"
                [(ngModel)]="dokTipusSzuro"
                (ionChange)="loadGeneraltDokumentumok()"
              >
                <ion-select-option value="">Összes</ion-select-option>
                <ion-select-option value="bizonyitvany">Bizonyítvány</ion-select-option>
                <ion-select-option value="potlap">Bizonyítvány-pótlap</ion-select-option>
                <ion-select-option value="torzslap">Törzslap</ion-select-option>
                <ion-select-option value="hatarozat">Határozat</ion-select-option>
                <ion-select-option value="kerveny">Kérvény</ion-select-option>
                <ion-select-option value="beadvany">Beadvány</ion-select-option>
                <ion-select-option value="nyomtatvany">Kötelező nyomtatvány</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col size="4" size-md="2" class="ion-align-self-end">
              <ion-button expand="block" (click)="loadGeneraltDokumentumok()" [disabled]="dokBetolt">
                <ion-icon slot="start" name="refresh-outline"></ion-icon>
                Keresés
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>

        <div *ngIf="dokBetolt" class="ion-text-center ion-padding">
          <ion-spinner name="crescent"></ion-spinner>
        </div>

        <ion-list *ngIf="!dokBetolt" lines="full">
          <ion-item *ngFor="let d of generaltDokumentumok" [class.dok-ervenytelen]="d.ervenytelen">
            <ion-label class="ion-text-wrap">
              <!-- A kötelező nyomtatványok (beírási napló, osztálynapló …) nem egy tanulóé: ott a neve a cím. -->
              <h2>{{ d.tanulo_nev || d.oktazon || (d.tipus === 'nyomtatvany' ? d.nev : '—') }}</h2>
              <p>
                {{ dokTipusNev(d.tipus) }} · {{ d.nev }}
                <span *ngIf="d.oktazon"> · {{ d.oktazon }}</span>
              </p>
              <p class="dok-datum">{{ d.letrehozva | date:'yyyy.MM.dd. HH:mm' }}</p>
            </ion-label>

            <div slot="end" class="dok-jobb">
              <ion-badge *ngIf="d.ervenytelen" color="medium">Régi verzió</ion-badge>
              <ion-badge *ngIf="!d.ervenytelen && d.alairt" color="success">Aláírt</ion-badge>
              <ion-button
                *ngIf="!d.ervenytelen && d.path && d.tipus === 'bizonyitvany'"
                fill="outline"
                size="small"
                (click)="diszpeldany(d)"
              >
                <ion-icon slot="start" name="ribbon-outline"></ion-icon>
                Díszpéldány
              </ion-button>
              <ion-button
                *ngIf="!d.ervenytelen && d.path"
                fill="outline"
                size="small"
                [href]="fileUrl(d.path)"
                target="_blank"
              >
                <ion-icon slot="start" name="download-outline"></ion-icon>
                Letöltés
              </ion-button>
              <!-- Újrageneráláskor a korábban kiadott példány megmarad (archiv_path). -->
              <ion-button
                *ngIf="d.ervenytelen && d.archiv_path"
                fill="clear"
                size="small"
                [href]="fileUrl(d.archiv_path)"
                target="_blank"
                title="A felülírás előtt kiadott példány"
              >
                <ion-icon slot="start" name="archive-outline"></ion-icon>
                Korábbi példány
              </ion-button>
            </div>
          </ion-item>

          <ion-note color="medium" *ngIf="!generaltDokumentumok.length" class="ion-padding" style="display:block;">
            Nincs a szűrésnek megfelelő dokumentum.
          </ion-note>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <!-- Archív átadás (Nkt. 57. § (9a)–(9b)): a bizonyítványok átadási csomagja és a jogutódi hozzáférés. -->
    <ion-card *ngIf="nezet === 'archiv'">
      <ion-card-header>
        <ion-card-title>Archív átadás</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <app-archiv-atadas></app-archiv-atadas>
      </ion-card-content>
    </ion-card>
</div>

<!-- Bizonyítvány-modál: iktatószám, keltezés, sorszám + pótlap-sorozat, nevelőtestületi határozat
     (20/2012. EMMI r. 96. §; backend/bizonyitvany-tartalom.js). Az aláírt pótlaphoz is ez nyílik. -->
<ion-modal [isOpen]="iktatoModalOpen" (didDismiss)="closeIktatoModal()" class="biz-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ bizModalMod === 'potlap' ? 'Bizonyítvány-pótlap' : 'Bizonyítvány adatai' }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeIktatoModal()">Bezárás</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ng-container *ngIf="bizModalMod === 'bizonyitvany'">
        <p class="ion-padding-horizontal" *ngIf="iktatoIktatgato">
          <strong>Az iktatószámot az Iktatgató adja:</strong> a generálás tanulónként iktatja a bizonyítványt a
          „Bizonyítványok” iktatókönyvbe (ha nincs, létrehozza), az aláírt PDF-et csatolja, és legalább 80 év megőrzést állít be.
          <ng-container *ngIf="iktatoTanev">Tanév: <strong>{{ iktatoTanev }}</strong>.</ng-container>
          A már iktatott tanulók a meglévő számukat kapják vissza.
        </p>
        <p class="ion-padding-horizontal" *ngIf="!iktatoIktatgato">
          Add meg minden tanulóhoz a bizonyítvány iktatószámát.
          <ng-container *ngIf="iktatoTanev">Tanév: <strong>{{ iktatoTanev }}</strong>.</ng-container>
          A rendszer tanévenként megjegyzi, így újrageneráláskor ugyanaz jön vissza; új tanévben újra meg kell adni.
        </p>
      </ng-container>
      <p class="ion-padding-horizontal" *ngIf="bizModalMod === 'potlap'">
        A kijelölt tanulóknak aláírt, időbélyegzett pótlap készül, és a dokumentumtárba kerül (a szülő is letöltheti).
        <ng-container *ngIf="iktatoTanev">Tanév: <strong>{{ iktatoTanev }}</strong>.</ng-container>
      </p>

      <!-- Keltezés (96. § (3) k)): alapértéke a tanév utolsó tanítási napja -->
      <ion-item lines="full" class="biz-keltezes">
        <ion-input type="date" label="Keltezés" label-placement="stacked" [(ngModel)]="keltezes"></ion-input>
      </ion-item>
      <div class="biz-keltezes-valaszto" *ngIf="keltezesek.length">
        <ion-chip *ngFor="let k of keltezesek" [outline]="keltezes !== k.datum" (click)="keltezes = k.datum">
          <ion-label>{{ k.cimke }}: {{ k.datum | date:'yyyy.MM.dd.' }}</ion-label>
        </ion-chip>
      </div>
      <!-- A nevelőtestület határozatának száma és kelte (96. § (3) j)) – osztályra, tanévenként megjegyezve -->
      <ng-container *ngIf="bizModalMod === 'bizonyitvany'">
        <ion-item lines="full" class="biz-keltezes">
          <ion-input label="A nevelőtestületi határozat száma" label-placement="stacked" placeholder="pl. 12/2026."
                     [(ngModel)]="hatarozatSzam" maxlength="100"></ion-input>
        </ion-item>
        <ion-item lines="full" class="biz-keltezes">
          <ion-input type="date" label="A határozat kelte (az évzáró osztályozó értekezlet napja)" label-placement="stacked"
                     [(ngModel)]="hatarozatKelte"></ion-input>
        </ion-item>
      </ng-container>
      <ion-note color="warning" *ngIf="tartalomHiba" class="biz-megjegyzes">{{ tartalomHiba }}</ion-note>
      <ion-note color="warning" *ngIf="bizModalMod === 'bizonyitvany' && sablonHianyok.length" class="biz-megjegyzes">
        A bizonyítvány-sablonból hiányzik (20/2012. EMMI r. 96. §): {{ sablonHianySzoveg }}. A bizonyítvány így is
        elkészül, de ezek nélkül – frissített sablon: Papír bizonyítvány › Sablonok.
      </ion-note>

      <div class="biz-eszkozsor" *ngIf="!iktatoBetolt && iktatoNevsor.length">
        <ion-button size="small" fill="outline" (click)="sorszamokMentese()" [disabled]="sorszamMentes || !aktTanevEv">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          Sorszámok mentése
        </ion-button>
        <ion-button size="small" fill="outline" *ngIf="bizModalMod === 'bizonyitvany'" (click)="osszesJavaslatJovahagy()">
          <ion-icon slot="start" name="checkmark-done-outline"></ion-icon>
          Minden határozat-javaslat jóváhagyása
        </ion-button>
        <ion-note color="medium" *ngIf="bizModalMod === 'potlap'">{{ kijeloltSzam }} / {{ iktatoNevsor.length }} tanuló kijelölve</ion-note>
      </div>

      <div *ngIf="iktatoBetolt" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Névsor betöltése…</p>
      </div>

      <div *ngIf="!iktatoBetolt" class="biz-lista">
        <div *ngFor="let t of iktatoNevsor; let i = index" class="biz-sor">
          <ion-checkbox
            *ngIf="bizModalMod === 'potlap'"
            [checked]="t.kijelolve"
            (ionChange)="t.kijelolve = $event.detail.checked"
          ></ion-checkbox>
          <div class="biz-sor-tartalom">
            <div class="biz-sor-fej">
              <ion-label class="ion-text-wrap">
                <h2>{{ t.nev }}</h2>
                <p>{{ t.oktazon }}<span *ngIf="t.tantargySzam"> · {{ t.tantargySzam }} tantárgy</span></p>
              </ion-label>
              <ion-input
                *ngIf="bizModalMod === 'bizonyitvany'"
                class="iktato-input"
                label="Iktatószám"
                label-placement="stacked"
                [(ngModel)]="t.iktatoszam"
                [readonly]="iktatoIktatgato"
                [placeholder]="iktatoIktatgato ? 'iktatáskor' : 'Iktatószám'"
                [class.iktato-hiba]="!iktatoIktatgato && !t.iktatoszam?.trim()"
              ></ion-input>
              <ion-input
                class="iktato-input"
                label="Bizonyítvány sorszáma"
                label-placement="stacked"
                [(ngModel)]="t.sorszam"
                placeholder="pl. AB 1234567"
              ></ion-input>
              <ion-input
                class="iktato-input"
                label="Pótlap sorozatszáma"
                label-placement="stacked"
                [(ngModel)]="t.potlap_sorozat"
                placeholder="ha van pótlap"
              ></ion-input>
            </div>
            <p class="biz-oroklott" *ngIf="t.sorszam_ev && aktTanevEv && t.sorszam_ev !== aktTanevEv">
              A sorszám a {{ tanevFelirat(t.sorszam_ev) }}. tanévtől érvényes (ugyanaz a bizonyítvány).
            </p>

            <!-- Nevelőtestületi határozat (96. § (3) j)): a záradék, vagy jóváhagyandó javaslat a jegyekből -->
            <div class="biz-hatarozat" *ngIf="bizModalMod === 'bizonyitvany' && t.javaslat">
              <p *ngIf="t.javaslat.allapot === 'zaradek'" class="biz-zaradek">
                <ion-icon name="document-text-outline"></ion-icon>
                Határozat (záradék): {{ (t.javaslat.zaradek || []).join(' ') }}
              </p>
              <p *ngIf="t.javaslat.allapot === 'nincs_adat'" class="biz-figyelem">
                Nincs záradék és nincs év végi tantárgyi minősítés – a határozatot a Záradék menüben rögzítsd.
              </p>
              <ng-container *ngIf="vanJavaslat(t)">
                <ion-textarea
                  label="Határozat-javaslat (a jegyekből – jóváhagyás után kerül a bizonyítványra és záradékként a törzslapra)"
                  label-placement="stacked"
                  fill="outline"
                  [autoGrow]="true"
                  [rows]="2"
                  [(ngModel)]="t.hatarozatSzoveg"
                  (ionInput)="t.hatarozatJovahagyva = false"
                ></ion-textarea>
                <div class="biz-alternativak" *ngIf="t.javaslat.alternativak.length > 1">
                  <ion-chip *ngFor="let a of t.javaslat.alternativak" [outline]="t.hatarozatSzoveg !== a"
                            (click)="t.hatarozatSzoveg = a; t.hatarozatJovahagyva = false">
                    <ion-label>{{ a }}</ion-label>
                  </ion-chip>
                </div>
                <p class="biz-indoklas">{{ t.javaslat.indoklas }}</p>
                <p class="biz-figyelem" *ngFor="let f of t.javaslat.figyelmeztetesek">{{ f }}</p>
                <ion-checkbox
                  labelPlacement="end"
                  [checked]="t.hatarozatJovahagyva"
                  [disabled]="!(t.hatarozatSzoveg || '').trim()"
                  (ionChange)="t.hatarozatJovahagyva = $event.detail.checked"
                >A nevelőtestület határozatát jóváhagyom</ion-checkbox>
              </ng-container>
            </div>
          </div>
        </div>
        <ion-note color="medium" *ngIf="!iktatoNevsor.length" class="ion-padding">
          Nincs betölthető névsor ehhez az osztályhoz.
        </ion-note>
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-note slot="start" color="warning" class="biz-lab-megjegyzes"
                  *ngIf="bizModalMod === 'bizonyitvany' && !iktatoBetolt && iktatoNevsor.length && hatarozatNelkul">
          {{ hatarozatNelkul }} tanulónál nincs záradék vagy jóváhagyott határozat.
        </ion-note>
        <ion-buttons slot="end">
          <ion-button (click)="closeIktatoModal()">Mégse</ion-button>
          <ion-button
            color="secondary"
            fill="solid"
            (click)="confirmIktatoAndGenerate()"
            [disabled]="toprengoFolyamatban || iktatoBetolt || !iktatoNevsor.length || iktatoHianyzik || (bizModalMod === 'potlap' && !kijeloltSzam)"
          >
            <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
            Generálás és aláírás
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
